import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import NewReleasesOutlinedIcon from '@mui/icons-material/NewReleasesOutlined';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import releaseNotesMd from '../content/release-notes.md?raw';

// Parsed once at module scope — the content is static and ships with the bundle.
const releaseNotesHtml = DOMPurify.sanitize(marked.parse(releaseNotesMd) as string);

export default function ReleaseNotes() {
  return (
    <Stack spacing={3} sx={{ px: 3 }}>
      <Box>
        <Typography
          variant="h4"
          component="h1"
          sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}
        >
          <NewReleasesOutlinedIcon color="primary" sx={{ fontSize: '0.9em' }} />
          Release Notes
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: '65ch' }}>
          What&apos;s new in CPAx Academy.
        </Typography>
      </Box>

      <Card
        elevation={0}
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: '8px',
        }}
      >
        <CardContent sx={{ p: { xs: 2.5, sm: 3 } }}>
          <Box
            sx={{
              maxWidth: '75ch',
              // Map the rendered markdown onto theme typography instead of
              // browser defaults. One h2 per release; a divider separates them.
              '& h2': {
                typography: 'h6',
                mt: 4,
                mb: 1,
                pt: 3,
                borderTop: '1px solid',
                borderColor: 'divider',
              },
              '& h2:first-of-type': { mt: 0, pt: 0, borderTop: 'none' },
              '& h3': { typography: 'subtitle2', mt: 2, mb: 0.5 },
              '& p': { typography: 'body2', color: 'text.secondary', my: 1 },
              '& ul': { pl: 3, my: 1 },
              '& li': {
                typography: 'body2',
                color: 'text.secondary',
                mb: 0.75,
                lineHeight: 1.6,
              },
              '& a': { color: 'primary.main' },
            }}
            dangerouslySetInnerHTML={{ __html: releaseNotesHtml }}
          />
        </CardContent>
      </Card>
    </Stack>
  );
}
